import { Box, Typography } from '@mui/material';
import React, { ReactNode } from 'react';
import { CustomButton } from './styles';

interface ButtonProps {
  id: string;
  type?: 'button' | 'submit' | 'reset';
  fullWidth: boolean;
  title?: string;
  buttonStyle: object;
  disable?: boolean;
  onClick?: (event: React.MouseEvent<HTMLElement>) => void;
  boxStyle?: object;
  startIcon?: ReactNode;
  endIcon?: ReactNode;
  sxTextStyle?: object;
}

const Button: React.FC<ButtonProps> = ({ id, type = 'submit', fullWidth, title, buttonStyle, disable, onClick, boxStyle, startIcon, endIcon, sxTextStyle }) => {
  return (
    <Box sx={{ width: '100%', cursor: 'pointer', ...boxStyle }}>
      <CustomButton
        disabled={disable}
        id={id}
        fullWidth={fullWidth}
        size="large"
        type={type}
        variant="contained"
        sx={{
          ...buttonStyle,
        }}
        onClick={onClick}
        startIcon={startIcon}
        endIcon={endIcon}
      >
        {title && <Typography sx={{ ...sxTextStyle }}>{title}</Typography>}
      </CustomButton>
    </Box>
  );
};

export default Button;
